var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6549 5.47999L9.65488 3.72999C9.23488 3.57999 8.77488 3.57999 8.35488 3.71999L4.36488 5.05999C3.55488 5.33999 3.00488 6.09999 3.00488 6.95999V18.81C3.00488 20.22 4.41488 21.18 5.72488 20.67L8.65488 19.53C8.87488 19.44 9.12488 19.44 9.34488 19.52L14.3449 21.27C14.7649 21.42 15.2249 21.42 15.6449 21.28L19.6349 19.94C20.4449 19.67 20.9949 18.9 20.9949 18.04V6.18999C20.9949 4.77999 19.5849 3.81999 18.2749 4.32999L15.3449 5.46999C15.1249 5.54999 14.8849 5.55999 14.6549 5.47999ZM15.0049 19.39L9.00488 17.28V5.60999L15.0049 7.71999V19.39Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.2da13cee.svg";
export { ForwardRef as ReactComponent };